const Pristine = require('pristinejs')

export function formOpretBruger() {
    let forms = document.querySelectorAll('.js-opret_bruger');

    if (!forms) {
        return;
    }


    forms.forEach((form) => {

        let pristine = new Pristine(form, null, false);

        form.addEventListener('submit', function (e) {
            e.preventDefault();

            let valid = pristine.validate();

            if (!valid) {
                return;
            }

            let formData = new FormData(form);

            formData.append('action', 'create_user')
            formData.append('_wpnonce', ajax_object.wp_nonce)

            let request = new XMLHttpRequest(),
                method = 'POST',
                url = ajax_object.ajax_url,
                btn = form.querySelector('button');

            btn.classList.remove('btn-background');
            btn.classList.add('btn-border', 'btn-icon', 'btn-loader');
            btn.innerText = '';

            request.open(method, url, true);

            request.send(formData)

            request.onerror = function () {
                console.log('ERROR: ' + this.response);
            }

            request.onload = function () {
                let res = JSON.parse(this.response);

                if(res.success === false && res.data.type == 'email'){
                    pristine.addError(form.querySelector('#email'), res.data.message)
                    btn.classList.remove('btn-border','btn-icon','btn-loader')
                    btn.classList.add('btn-background')
                    btn.innerText = 'Opret'
                    return
                }

                if(res.success === false && res.data.type == 'password'){
                    pristine.addError(form.querySelector('#pwd'), res.data.message)
                    pristine.addError(form.querySelector('#repwd'), res.data.message)
                    btn.classList.remove('btn-border','btn-icon','btn-loader')
                    btn.classList.add('btn-background')
                    btn.innerText = 'Opret'
                    return
                }

                if(res.success === false && res.data.type == 'error'){
                    console.log('ERROR:' + res.data.message);
                    return
                }

                if(res.success === true){
                    location.reload();
                }
            }
        })
    })
}